import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="toggle"
export default class extends Controller {
	static targets = ["target"];
	static classes = ["css"];
	static values = { disableFields: Boolean };

	connect() {
		this.syncDisabledFields();
	}

	toggle() {
		this.targetTargets.forEach((target) => {
			target.classList.toggle(...this.cssClasses);
			if (target.dataset.toggleState) {
				target.dataset.toggleState = target.dataset.toggleState === "true" ? "false" : "true";
			}
		});
		this.syncDisabledFields();
	}

	show() {
		this.targetTargets.forEach((target) => {
			target.classList.add(...this.cssClasses);
			if (target.dataset.toggleState) {
				target.dataset.toggleState = target.dataset.toggleState === "true";
			}
		});
		this.syncDisabledFields();
	}

	hide() {
		this.targetTargets.forEach((target) => {
			target.classList.remove(...this.cssClasses);
			if (target.dataset.toggleState) {
				target.dataset.toggleState = target.dataset.toggleState === "false";
			}
		});
		this.syncDisabledFields();
	}

	syncDisabledFields() {
		if (!this.disableFieldsValue) return;

		this.targetTargets.forEach((target) => {
			const hidden = this.cssClasses.every((className) => target.classList.contains(className));
			target.querySelectorAll("input, select, textarea").forEach((field) => {
				field.disabled = hidden;
			});
		});
	}
}
